import { FC } from 'react';
import { Badge, Text } from '../../../shared/uiComponents';
import { InsuranceDetailProperties } from '../../../redux/API/ClientAPIHelpers/insuranceProperties';

interface BillingRulesCardProps {
	insurance: InsuranceDetailProperties;
}

const BillingRulesCard: FC<BillingRulesCardProps> = ({ insurance }) => (
	<div className="insuranceDetailCard">
		<Text title="Billing Rules" type="h6" fontWeight="semiBold" />
		<div style={{ marginTop: '20px' }}>
			<div className="insuranceDetailInfoRow">
				<Text title="Allow LBA without BCBA:" type="psm" fontWeight="semiBold" />
				<Badge
					label={insurance.allowedLbaWithoutBcba ? 'Yes' : 'No'}
					type={insurance.allowedLbaWithoutBcba ? 'success' : 'gray'}
					sizeType="sm"
				/>
			</div>

			<div className="insuranceDetailInfoRow">
				<Text title="Two BCBAs same day:" type="psm" fontWeight="semiBold" />
				<Badge
					label={insurance.twoBcbaCanBillAtSameDay ? 'Yes' : 'No'}
					type={insurance.twoBcbaCanBillAtSameDay ? 'success' : 'gray'}
					sizeType="sm"
				/>
			</div>

			<div className="insuranceDetailInfoRow">
				<Text title="Limited BCBAs bill as non-credentialed:" type="psm" fontWeight="semiBold" />
				<Badge
					label={insurance.limitedBcbasBillAsNotCredentialed ? 'Yes' : 'No'}
					type={insurance.limitedBcbasBillAsNotCredentialed ? 'success' : 'gray'}
					sizeType="sm"
				/>
			</div>
		</div>
	</div>
);

export default BillingRulesCard;
